<template>
  <div class="turn-copyright">
    <div>本區商品、規格、顏色、價格、贈品<br>以遠傳friDay購物-購物車結帳頁面為準，敬請見諒</div>
    <div> 遠時數位科技股份有限公司為遠傳電信集團關係企業/版權所有<br>Copyright © 2022 All Rights Reserved by YSDT. <a href="https://m.shopping.friday.tw/intro/privacy-intro" target="_blank">隱私權政策</a><br>營業人名稱: 遠時數位科技股份有限公司 統一編號: 54349098</div>
  </div>
</template>

<script>
export default {
  name: 'app-footer'
}
</script>

<style lang="scss" scoped>
@import "../../style/_color.scss";

.turn-copyright {
  padding: 0 10px;
  >div {
    &:first-child {
      margin: 10px 0;
      font-size: 1.1rem;
      text-align: center;
    }
    &:last-child {
      padding-bottom: 15px;
      font-size: 0.8rem;
      text-align: center;
      color: $dustygray;
    }
  }
}

@media screen and (max-width: 374px) {
  .turn-copyright {
    display: none;
  }
}
</style>